import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth.service';
import { PermissionsEnum } from '../../../api/api-reference';

@Component({
  selector: 'app-scheduled-menu',
  standalone: true,
  imports: [TranslateModule, CommonModule, RouterOutlet],
  templateUrl: './scheduled-menu.component.html',
  styleUrl: './scheduled-menu.component.scss',
})
export class ScheduledMenuComponent {
  public PermissionsEnum = PermissionsEnum;
  constructor(private router: Router, public authService: AuthService) {}

  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }
  navigate(route: string) {
    this.router.navigate([route]);
  }
}
